    const ColumnPropertiesJson = {
        "Basic" :{
            "ColumnName" : "",
            "ColumnType" : "",
            "ColumnWidth" : "",
            "SortingType" : "",
            "ShowToolTipAsInfoIcon":"",
            "AssociatedField" : "",
            "ColumnTooltip" : "",
            // "MaskingPattern" : "",
            // "MaskingValue":"",
            "ColumnMasking":"",
            "GridMasterQuery": "",
            "VisibleOnTable" : "",
            "EnableSearch" : "",
            "AllowDuplicate" : "",
            "ShowTotalListview" : "",
            "ShowHeaderLabel" : "",
            // "ShowCellData" : "",
            "DisplayLabelValue" : "",
        },
        "InputValidations" : { 
                     "SaveEncrypted" : "",
                     "ShowDecrypted" : "",
                     "AllowAlphabets" : "",
                     "AllowSpaces" : "",
                     "AllowNumbers" : "",
                     "AllowSpecialChars" : "",
                     "exBox" : "",
                     "columnCharacterSet" : "",
                     "columnMinValue" : "",
                     "columnMaxValue" : "",
                     "columnMaxLength" : "",
                     "columnCustomPattern" : ""
                     },
        "Appearance" : { 
                    // "ColumnHeader" : "",
                    "ColumnHeaderFontWeight" : "",
                    "ColumnHeaderColor" : "",
                    "ColumnHeaderAlignment" : "",
                    // "ColumnValues" : "",
                    "ColumnValuesFontWeight" : "" ,
                    "ColumnValuesColor" : "",
                    "ColumnValuesAlignment" : "",
                    "TableTextAreaHeight": 75,
                    "RadioAlignment": ""
                },
        "ButtonAppearance" : {
                    "ButtonLabel": "",
                    "MethodName1":"",
                    "TableButtonImageFile":"",
                    "ButtonType":"",
                    "FontSize": "",
                    "CornerRadius": "",
                    "BackgroundColor": "",
                    "BorderColor": "",
                    "FontColor": "",

                    "ColumnHeaderButton" : "",
                    "ColumnHeaderAlignment" : "",
                    "ColumnValueButton" : "",
                    "ColumnValuesAlignment" : "",
        },
        "textbox" : {
            
        },
        "textarea" : {
            
        },
        "label": {
            "TableColumnLabel": "",
            "heading": "Label",
            "MethodName1": "",
        },
        "link": {
            "TableColumnLabel": "",
            "MethodName1": "",
            "ListviewLinkURL": "",
            "heading": "Label"
        },
        "button" : {
            'FontStyle' : '',
            'BackgroundColor' : '',
            'CornerRadius' : '',
        },
        "datepick" : {
            'heading' : 'Date Configurations',
            'left' : {
                        "DateFormat" : "",
                        "MinDate" : "",
                        "MinDateAsCurrentTable":"",
                        "MaxDate" :"",
                        "MaxDateAsCurrentTable":"",
                        "ManualInput": "",
                        // "DefaultStateLabel":"",
                        // "DefaultValue":{label:["Current Date & Time", "None"],id:"DefaultValue"},
                    },
            'right' : {
                // "GridDateSeperator": ""
            //     "AllowManualInput" : "",
            //     "MinDate" : "",
            //     "MinDateAsCurrent":"",
            }
        },
        "dropdown" : {
            'heading' : 'Options',
            'optionAddition' : 'optionAdditionType',
            'button' : 'AddOption',
            'Query': { 'label': "Database Query", 'field': "DBQuery", 'regexType': "Allchar" },
        },
        "combo" : {
            'heading' : 'Options',
            'optionAddition' : 'optionAdditionType',
            'button' : 'AddOption'
        },
        "multiselect" : {
            'heading' : 'Options',
            'optionAddition' : 'optionAdditionType',
            'button' : 'AddOption'
        },
        "listbox" : {
            'heading' : 'Options',
            'optionAddition' : 'optionAdditionType',
            'Query': { 'label': "Database Query", 'field': "Query", 'regexType': "Allchar" },
            'Cache' : {'type':'toggleallow', 'label':'Enable Caching', 'children':[]},
            // 'button' : 'AddOption'
        },
        "picklist" : {
            'heading' : 'Options',
            'optionAddition' : 'optionAdditionType',
            'Query': { 'label': "Database Query", 'field': "Query", 'regexType': "Allchar" },
            'Cache' : {'type':'toggleallow', 'label':'Enable Caching', 'children':[]},
            // 'button' : 'AddOption'
        },
        "checkbox" : {

        },
        "radio" : {
            'heading' : 'Options',
            'optionAddition' : 'optionAdditionType',
            'button' : 'AddOption'
        },
        "toggle" : {
            'heading' : 'Toggle States',
            "ToggleStates" : "",
            'ShowToggleStateBesideSwitch' : ''
        }

}

export default ColumnPropertiesJson;
